
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 16\" id=\"plus\" ><defs/><title>plus</title><g id=\"plus_Layer_2\" data-name=\"Layer 2\"><g id=\"plus_Icons\"><path class=\"cls-1\" d=\"M0 6.59h6.59V0h2.82v6.59H16v2.82H9.41V16H6.59V9.41H0V6.59z\" id=\"plus_plus\"/></g></g></symbol>";
module.exports = sprite.add(image, "plus");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus.svg
// module id = 664
// module chunks = 1474